// @flow

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import I18n from '../../i18n/I18n';

import ArrayUtils from '../../utils/ArrayUtils';

// -- views
import LocalizableSelect from './LocalizableSelect';

export default class LocaleChooser extends Component {

  static defaultProps = {
    clearable: true,

    readOnly: false,

    multi: false,

    values: [],

    value: null,
  };

  static propTypes = {
    values: PropTypes.array,

    value: PropTypes.string,

    multi: PropTypes.bool,

    // param: number, the chosen vat
    onChange: PropTypes.func.isRequired,

    clearable: PropTypes.bool,

    readOnly: PropTypes.bool,

    /**
     * The locales to propose
     */
    locales: PropTypes.arrayOf(PropTypes.string).isRequired,
  };

  onSelect = (options: SelectOption | SelectOptions) => {
    if (this.props.multi) {
      const locales: Array<Locale> = options.map((option: SelectOption) => {
        return option.value;
      });

      this.props.onChange(locales);
    } else {
      if (_.isNull(options)) {
        this.props.onChange(null);
      } else {
        this.props.onChange(options.value);
      }
    }
  };

  render() {
    const values = !_.isNull(this.props.value) ? [ this.props.value ] : this.props.values;

    const selectValues: SelectOptions = [];
    const options: SelectOptions = this.props.locales.map((locale: string) => {
      const option: SelectOption = {
        label: I18n.getLocale(locale),
        value: locale,
      };

      const found = ArrayUtils.exists(values, (value: Locale) =>  { return value === locale });
      if (found) {
        selectValues.push(option);
      }

      return option;
    });

    return (
      <div className="locale_chooser">
        <LocalizableSelect
          name="action"
          value={this.props.multi ? selectValues : selectValues[0]}
          options={options}
          onChange={this.onSelect}
          clearable={this.props.clearable}
          disabled={this.props.readOnly}
          multi={this.props.multi}
        />
      </div>
    );
  }

}
